module.exports = "/_next/static/media/8382094d476e42ce2d0c4d13c825c8dc.svg";